/* QuadrantMenuRenderer.js */

"use strict";

const AvailableDockletsComponent = require("./availableDocklets/AvailableDockletsComponent");
const ActiveDockletsComponent = require("./activeDocklets/ActiveDockletsComponent");

class QuadrantMenuRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("quadrant-menu"); //TODO Setup the root Element
        this._rootElem.component = this._model;
        this._rootElem.setAttribute("tabindex", -1);
        this._availableDocklets = new AvailableDockletsComponent({state: this._model._state});
        this._activeDocklets = new ActiveDockletsComponent({state: this._model._state});
        this.rootElement.appendChild(this._activeDocklets.renderer.rootElement);
        this.rootElement.appendChild(this._availableDocklets.renderer.rootElement);
        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/
    _shutdown() {
        this._unregisterListeners();
        this._availableDocklets.shutdown();
        this._availableDocklets = null;
        this._activeDocklets.shutdown();
        this._activeDocklets = null;
        this._rootElem.component = null;
        this._rootElem.remove();
        this._rootElem = null;
        this._model = null;
        return Promise.resolve();
    }

    _registerListeners() {
        this._onBlurHandler = this._onBlurHandler.bind(this);
        this._onMouseEnterHandler = this._onMouseEnterHandler.bind(this);
        this._onMouseLeaveHandler = this._onMouseLeaveHandler.bind(this);
        this._model.on("Shutdown", () => this._shutdown());
        this._availableDocklets.on("pinIconClicked", () => {
            this._model.togglePinned();
        });
        this._availableDocklets.on("activateDocklet", (type) => {
            this._model.activateDocklet(type);
        });
        this._registerDomListeners();
    }

    _registerDomListeners() {
        this.rootElement.addEventListener("blur", this._onBlurHandler);
        this.rootElement.addEventListener("mouseenter", this._onMouseEnterHandler);
        this.rootElement.addEventListener("mouseleave", this._onMouseLeaveHandler);
    }

    _unregisterDomListeners() {
        this.rootElement.removeEventListener("blur", this._onBlurHandler);
        this.rootElement.removeEventListener("mouseenter", this._onMouseEnterHandler);
        this.rootElement.removeEventListener("mouseleave", this._onMouseLeaveHandler);
    }

    _unregisterListeners() {
        this._unregisterDomListeners();
    }

    /**
     * handles closing the options when the list loses focus
     */
    _onBlurHandler() {
        this._model.closeOptionsOnBlur();
    }

    /**
     * Handles the mouseenter event for the container
     */
    _onMouseEnterHandler() {
        this._model.showMenu();
    }

    /**
     * Handles the mouseleave event for the container
     */
    _onMouseLeaveHandler() {
        this._model.hideMenu();
    }

    _setOptionsState() {
        if (this._model.getOptionsOpenedState()) {
            this._openOptions();
        } else {
            this._closeOptions();
        }
    }

    /**
     * opens the options display
     */
    _openOptions() {
        this.rootElement.classList.add("options-opened");
    }

    /**
     * Closes the options display
     */
    _closeOptions() {
        this.rootElement.classList.remove("options-opened");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */

    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     */
    render() {
        return Promise.resolve()
            .then(() => {
                this._availableDocklets.renderer.render();
            })
            .then(() => {
                return this._activeDocklets.renderer.render();
            })
            .then(() => {
                return this._setOptionsState();
            });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = QuadrantMenuRenderer;
